import React, { FC } from 'react';

import { KeyResultI } from '~src/store/okrs/keyResultStream/interfaces';
import { ElementWrapper, UpdateButtonContainer } from '~src/modules/okrs/manageObjectives/shared/shared.sc';
import AvatarsRow from '~src/shared/avatarsRow/AvatarsRow';
import { ownerToSegment } from '~src/modules/okrs/manageObjectives/shared/utils';
import { LastRow, ListElementWrapper } from '~src/modules/okrs/manageObjectives/edit/editListItem.sc';
import { Weighting } from '~src/modules/okrs/manageObjectives/shared/Weighting';

import KeyResultProgress from './KeyResultProgress';
import KeyResultUpdateButton from './KeyResultUpdateButton';

interface Props {
  canEdit: boolean;
  keyResult: KeyResultI;
  onSelect: () => unknown;
  isSelected: boolean;
  onUpdateKeyResult?: () => void;
}

const EditKeyResultItem: FC<Props> = ({ isSelected, keyResult, canEdit, onUpdateKeyResult, onSelect }) => {

  return (
    <>
      <ListElementWrapper onClick={onSelect}>
        <ElementWrapper
          $selectable={true}
          className={isSelected ? 'selected' : ''}
        >
          <KeyResultProgress keyResult={keyResult} />
          <LastRow>
            {keyResult.owners && <AvatarsRow userData={keyResult.owners.map(ownerToSegment)} />}
            <Weighting weighting={keyResult.weighting} locked={keyResult.weighting_locked} />
          </LastRow>
          {canEdit && (
            <UpdateButtonContainer>
              <KeyResultUpdateButton keyResult={keyResult} onUpdateKeyResult={onUpdateKeyResult} />
            </UpdateButtonContainer>
          )}
        </ElementWrapper>
      </ListElementWrapper>
    </>
  );
};

export default EditKeyResultItem;
